export default Vue.mixin({
  data(){
    return {
      downloadError: ''
    }
  },

  methods: {

    /**
     * This method creates a temporary link tag in the DOM and simulates calls its click event
     * It is recomended to use the method testUrl to check for a success code before calling this method
     * 
     * @param {String} url The url of the file download
     * @param {StreamPipeOptions} filename The filename which should be used for saving
     * @param {Boolean} newTab True if the link should open in a new tab.
     * @returns {void}
     */
    downloadFile(url, filename, newTab=false) {
      this.downloadError = ''
      // Check if browser is InternetExplorer
      if (navigator.appVersion.toString().indexOf('.NET') > 0) {
        window.navigator.msSaveBlob(url, filename);
      } else {
        const link = document.createElement('a');
        link.href = encodeURI(url);
        if(newTab) link.target = '_blank'; // Open in a new tab
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link); // Remove the temp link
      }
    },

    /**
     * Calls the url and tests the response for success. 
     * The property downloadError is also populated with true or false so it can be used in the component if necessary
     * Use case, .error(v-if="downloadError") {{ $t('routes.button.downloadError') }}
     * @param {String} url 
     * @returns {Boolean} True on success False on fail
     */
    testUrl(url){
      this.downloadError = false
      return fetch(url, { method: 'HEAD' })
      .then(response => {
        this.downloadError = !response.ok
        return response.ok
      });
    }
  }
})
